export default "__VITE_ASSET__B6FS0tZ9__"